import { render, staticRenderFns } from "./InvoicingMainView.vue?vue&type=template&id=970f5124&scoped=true"
import script from "./InvoicingMainView.vue?vue&type=script&lang=js"
export * from "./InvoicingMainView.vue?vue&type=script&lang=js"
import style0 from "./InvoicingMainView.vue?vue&type=style&index=0&id=970f5124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970f5124",
  null
  
)

export default component.exports